
























/* General */
import Vue from 'vue'
import ProjectSettingsLayout from '@/layouts/project-settings-layout.vue'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'
import GuestMembershipManager from './components/guest-membership-manager.vue'

/* Helpers */

/* Data types */
import { EEntities } from '@/types'
import { IPersonBase } from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'ProjectSettingsAssignGuests',

  metaInfo(): any {
    return {
      title: `Add/Remove Guests - ${this.name}`,
    }
  },

  components: {
    ProjectSettingsLayout,
    EntitySettingsLoading,
    GuestMembershipManager,
  },

  data() {
    return {
      EEntities,
      name: '',
      assignedPeople: [] as IPersonBase[],
    }
  },

  computed: {
    id(): number {
      return parseInt(this.$route.params.id, 10)
    },
  },
})
